<div class="set-username-bottomsheet-container">
  <div class="set-username-bottomsheet-top" (swipedown)="swipe($event.type)">
    <div class="set-username-bottomsheet-top-indicator"></div>
  </div>
  <div class="set-username-bottomsheet-title">
    برای فعالیت در تریبون اول باید نام کاربری انتخاب کنید
  </div>
  <div
    class="set-username-bottomsheet-input-holder"
    [ngClass]="!hasError ? 'active-border' : 'disable-border'"
  >
    <input
      type="text"
      [(ngModel)]="username"
      (input)="checkAvailability()"
      placeholder="نام کاربری"
    />
    <div class="blog-search-remove" *ngIf="username" (click)="clearUsername()">
      <img src="assets/blog/close.svg" />
    </div>
    <!-- <img src="assets/plan/down-arrow-blue.svg"> -->
  </div>
  <div *ngIf="hasError" class="set-username-buttomsheet-error">
    {{ message }}
  </div>
  <mat-spinner *ngIf="showLoading" class="spinner"></mat-spinner>
  <div *ngIf="showLoading" class="spinner-holder"></div>
  <div
    *ngIf="!showLoading"
    [ngClass]="
      isButtonActive
        ? 'set-username-bottomsheet-submit submit-active'
        : 'set-username-bottomsheet-submit submit-disable'
    "
    (click)="submit()"
    id="set-button"
  >
    ثبت
  </div>
</div>
